import theme from '@css/theme';
import type { TrialPhase } from './types';

export const TRIAL_BADGE_COLORS: Record<Exclude<TrialPhase, 'hard_stop'>, string> = {
  active_safe: theme.token['yellow.4'],
  active_warning: theme.token['orange.3'],
  active_critical: theme.token['red.3'],
  grace_period: theme.token['red.3'],
};

export const FROZEN_PATTERN = `repeating-linear-gradient(
  -45deg,
  ${theme.token['red.3']},
  ${theme.token['red.3']} 2px,
  ${theme.token['red.2']} 2px,
  ${theme.token['red.2']} 4px
)`;
